const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2465,-1087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_6",
    transform: "matrix(1,0,0,1,2465.88,1087.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(117,169,65)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07225,0,0,1.06512,-36.3008,-32.8184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2465.88,-1087.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3225.72,1268.35C3231.38,1264.1 3238.56,1262.46 3245.49,1263.84C3252.41,1265.21 3258.44,1269.46 3262.08,1275.55C3283.01,1310.53 3313.31,1376.14 3302.13,1448.62C3289.46,1530.73 3246.02,1522.38 3185.14,1587.91C3150.8,1624.87 3148.6,1686.64 3111.22,1719.05C3049.54,1772.54 3022.74,1766.07 2961.62,1804.7C2927.21,1826.45 2898.86,1911.96 2840.64,1927.29C2752.9,1950.39 2686.8,1905.32 2651.24,1874.41C2641.08,1865.62 2639.61,1850.34 2647.89,1839.75C2681.79,1796.28 2663.17,1761.56 2699.16,1719.58C2727.92,1686.02 2802.56,1694.63 2837.91,1663.6C2872.51,1633.22 2865.27,1598.6 2906.35,1550.86C2962.39,1485.74 3009.31,1506.32 3042.98,1459.31C3076.65,1412.29 3050.06,1390.02 3082.05,1342.34C3122.78,1281.62 3184.49,1298.91 3225.72,1268.35Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.44557,0.594992,-0.603763,1.46688,-3049.33,-3724.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3216.65,1405.16C3242.15,1404.9 3250.51,1432.3 3250.51,1463.94C3250.51,1495.59 3233.73,1514.18 3215.23,1514.18C3196.74,1514.18 3183.14,1494.15 3183.14,1462.5C3183.14,1430.85 3198.16,1405.35 3216.65,1405.16Z",
    style: {
      fill: "rgb(117,169,65)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.41971,1.21081,-1.22866,1.44064,-2225.81,-5453.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3216.65,1405.16C3242.15,1404.9 3250.51,1432.3 3250.51,1463.94C3250.51,1495.59 3233.73,1514.18 3215.23,1514.18C3196.74,1514.18 3183.14,1494.15 3183.14,1462.5C3183.14,1430.85 3198.16,1405.35 3216.65,1405.16Z",
    style: {
      fill: "rgb(117,169,65)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.808499,1.50626,-1.44877,0.777642,-151.455,-5264.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3216.65,1405.16C3242.15,1404.9 3250.51,1432.3 3250.51,1463.94C3250.51,1495.59 3233.73,1514.18 3215.23,1514.18C3196.74,1514.18 3183.14,1494.15 3183.14,1462.5C3183.14,1430.85 3198.16,1405.35 3216.65,1405.16Z",
    style: {
      fill: "rgb(117,169,65)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.354d9ceb483bf65fce12ba26a6cff6fb.svg";
export { ForwardRef as ReactComponent };